import { useEffect, useRef, useState } from 'react'

import { PersonQuestion } from '../Icons'

interface SmoothVideoProps {
  src?: string
  poster?: string
  isOnScreen: boolean
  className?: string
  isFetching?: boolean
  loadedMentor: boolean
  showSkeleton?: boolean
}

export const SmoothVideo: React.FC<SmoothVideoProps> = ({
  src = '',
  poster,
  isOnScreen,
  className = '',
  loadedMentor,
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const [loaded, setLoaded] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false)

  useEffect(() => {
    setImageLoaded(false)
    setLoaded(false)
  }, [poster, src])

  const handleVideoReady = () => {
    requestAnimationFrame(() => {
      setLoaded(true)
    })
  }

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('playing', handleVideoReady)
    }
    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener('playing', handleVideoReady)
      }
    }
  }, [src])

  const handleImageLoad = () => {
    // Ensure opacity transition runs even if image loads instantly (e.g. from cache)
    requestAnimationFrame(() => {
      setImageLoaded(true)
    })
  }

  return (
    <div className={`relative w-full h-full  ${className}`}>
      {!loadedMentor && !loaded && !imageLoaded && (
        <div className="absolute inset-0 flex items-center justify-center ">
          <div className="animate-pulse w-[72px] bg-dark-neutral-400 h-[72px] min-w-[72px] -z-10 text-dark-neutral-800  flex items-center justify-center rounded-full">
            <PersonQuestion />
          </div>
        </div>
      )}

      {src ? (
        <video
          preload="auto"
          ref={videoRef}
          muted
          autoPlay
          loop
          playsInline
          controlsList="nodownload"
          disablePictureInPicture
          src={isOnScreen ? src : undefined}
          onLoadedData={handleVideoReady}
          className={`
            w-full h-full object-cover ${
              loaded ? 'opacity-100' : 'opacity-0'
            } ${loadedMentor ? '' : 'transition-opacity duration-500'}
          `}
        />
      ) : (
        poster && (
          <img
            src={poster}
            key={poster}
            onLoad={handleImageLoad}
            alt="poster"
            className={`w-full h-full object-cover ${
              imageLoaded ? 'opacity-100' : 'opacity-0'
            } ${loadedMentor ? '' : 'transition-opacity duration-500'}`}
          />
        )
      )}
    </div>
  )
}
